export default __webpack_public_path__ + "static/bolsa-gif-74e20aea9df9620123ec1d65fa47b09b.gif";